export const ICON_CDN_VERSION = 'v5';

export type IconName = (typeof ICON_NAMES)[number];
export type BrandedIconName = (typeof BRANDED_ICON_NAMES)[number];

export const ICON_NAMES = [
  '05x',
  '08x',
  '12x',
  '15x',
  '18x',
  '1x',
  '2x',
  '2x-circled',
  '6-dots',
  '6-squares',
  'abs',
  'abs-brake',
  'ac',
  'address-book',
  'air-distribution-face',
  'air-distribution-feet',
  'air-distribution-windscreen',
  'air-filter',
  'air-filter-particles',
  'air-filter-particles-clean',
  'airbag',
  'airbag-dashed',
  'airbag-off',
  'airbag-on',
  'alcohol-lock',
  'ambient-light',
  'ambient-light-auto',
  'american-football',
  'amp-meter',
  'animal',
  'aqi-circled',
  'ar',
  'arrow-back',
  'arrow-back-ch',
  'arrow-back-est',
  'arrow-back-forward',
  'arrow-back-st',
  'arrow-curved-back',
  'arrow-curved-forward',
  'arrow-curved-left',
  'arrow-deflected-up',
  'arrow-down',
  'arrow-down-back',
  'arrow-down-circled',
  'arrow-down-forward',
  'arrow-forward',
  'arrow-forward-car-side',
  'arrow-forward-car-side-off',
  'arrow-forward-ch',
  'arrow-forward-est',
  'arrow-forward-split',
  'arrow-forward-st',
  'arrow-merging',
  'arrow-up',
  'arrow-up-back',
  'arrow-up-forward',
  'arrow-up-line',
  'arrows-back-forward',
  'arrows-back-forward-square',
  'arrows-down-up',
  'arrows-multidirectional',
  'arrows-multidirectional-car',
  'arrows-split',
  'arrows-swap',
  'arrows-towbar',
  'asterisk',
  'audio-book',
  'audio-wave',
  'audio-wave-face',
  'auto',
  'auto-brake',
  'awd',
  'awd-arrows',
  'awd-car',
  'b-brake',
  'backspace',
  'band-aid',
  'bank',
  'basketball',
  'battery-10',
  'battery-100',
  'battery-20',
  'battery-30',
  'battery-40',
  'battery-50',
  'battery-60',
  'battery-70',
  'battery-80',
  'battery-90',
  'battery-frame',
  'battery-frame-dotted',
  'battery-frame-standing',
  'battery-frame-standing-car',
  'battery-frame-standing-minus',
  'battery-frame-standing-plus',
  'battery-standing-10',
  'battery-standing-100',
  'battery-standing-20',
  'battery-standing-30',
  'battery-standing-40',
  'battery-standing-50',
  'battery-standing-60',
  'battery-standing-70',
  'battery-standing-80',
  'battery-standing-90',
  'bed',
  'bell',
  'bell-phone',
  'bell-slashed',
  'bell-speedo',
  'bell-speedo-slashed',
  'bending-lights',
  'bill',
  'bills',
  'bills-circle-backwards',
  'bills-circle-forward',
  'bills-loop-forward',
  'bills-slashed',
  'blis',
  'blocked',
  'bluetooth',
  'bluetooth-connected',
  'bluetooth-connected-2',
  'bluetooth-connections',
  'bluetooth-runic-b',
  'bluetooth-runic-b-slashed',
  'bluetooth-slashed',
  'bolt',
  'book',
  'book-with-text',
  'bookmark',
  'books',
  'boom',
  'box-list-papers',
  'brake',
  'brake-fluid',
  'brake-light-crossed',
  'brake-pedal',
  'brake-pedal-auto',
  'brake-pedal-high',
  'brake-pedal-low',
  'brake-us',
  'break-pedal-waring',
  'briefcase',
  'broken-glass',
  'broom-and-bucket',
  'browse',
  'bug',
  'bulb',
  'calendar',
  'calendar-1-dot',
  'calendar-3-dots',
  'calendar-7-dots',
  'calendar-date',
  'calligraphy-pen',
  'camera',
  'camera-front',
  'camera-left-right',
  'camera-rear',
  'camera-record',
  'camera-rotate',
  'camera-side-left',
  'camera-slashed',
  'cancel-route',
  'car',
  'car-batteries',
  'car-battery',
  'car-circle',
  'car-framed',
  'car-moving',
  'car-overtake-left',
  'car-overtake-right',
  'car-pin',
  'car-rear',
  'car-roof-box',
  'car-sensors',
  'car-shadow',
  'car-side-arrow-inside',
  'car-side-profile',
  'car-side-profile-cropped',
  'card-charging',
  'card-key',
  'card-key-connected',
  'carplay',
  'cars',
  'charger-ccs',
  'charger-cn',
  'charger-cn-eu',
  'charger-eu',
  'charger-jp',
  'charger-jp-na',
  'charger-na',
  'charger-nacs',
  'charger-wireless',
  'charging-battery',
  'charging-battery-standing',
  'charging-note',
  'checked-calendar',
  'checklist',
  'checklist-car',
  'checklist-paper',
  'checkmark',
  'checkmark-circled',
  'checkmark-device',
  'checkmark-pin',
  'chevron-back',
  'chevron-back-double',
  'chevron-down',
  'chevron-forward',
  'chevron-forward-double',
  'chevron-up',
  'child',
  'child-lock-locked',
  'child-lock-unlocked',
  'chip-exclamation-mark',
  'chip-question-mark',
  'circle',
  'circle-1',
  'circle-2',
  'circle-3',
  'circle-4',
  'circle-5',
  'circle-arrow',
  'circle-backwards',
  'circle-backwards-10',
  'circle-backwards-15',
  'circle-backwards-30',
  'circle-backwards-5',
  'circle-backwards-credit-card',
  'circle-forward',
  'circle-forward-10',
  'circle-forward-15',
  'circle-forward-30',
  'circle-forward-5',
  'circle-forward-a',
  'circle-forward-cropped',
  'circle-grid',
  'circle-grid-plus',
  'circled-a',
  'circled-b',
  'circled-cross-list',
  'circled-plus-list',
  'circled-thumbs-up',
  'city',
  'climate-manikin',
  'clipboard',
  'clock',
  'clock-car',
  'clock-circle-forward',
  'clock-circle-forward-24h',
  'clock-circle-forward-large',
  'clock-circled',
  'clock-dotted',
  'closed-captions',
  'closed-captions-slashed',
  'cloud',
  'cloud-and-leaf',
  'cloud-connect',
  'cloud-download-battery',
  'cloud-download-checkmark',
  'cloud-download-clock',
  'cloud-download-exclamation',
  'cloud-download-loop-forward',
  'cloud-download-slashed',
  'cloud-slashed',
  'co2',
  'cobalt',
  'cobalt-search',
  'code',
  'coffee-cup',
  'cog',
  'cog-car',
  'cog-exclamation-mark',
  'cog-f',
  'cog-folder',
  'cog-o',
  'cog-p',
  'cog-profile',
  'cog-r',
  'cogs',
  'coins',
  'color-palette',
  'compass',
  'computer',
  'conference-table',
  'connect-plus',
  'connected-stethoscope',
  'content-tree',
  'contract-box',
  'contrast',
  'controller',
  'coolant',
  'credit-card',
  'credit-cards',
  'crop',
  'crosshair',
  'cta',
  'cta-slashed',
  'cube-3d',
  'cube-3d-divided',
  'cube-3d-one-side',
  'currency-usd',
  'curved-road-car',
  'defroster-front',
  'defroster-rear',
  'delivery-truck',
  'desks',
  'device',
  'diagnostics',
  'diamond',
  'diamond-cog',
  'diamond-sparkling',
  'digital-key',
  'disc',
  'display',
  'document',
  'download',
  'download-cloud',
  'download-paper',
  'download-square',
  'dresser',
  'drop',
  'drop-camera-front',
  'drop-camera-rear',
  'drop-fuel-pump',
  'drop-minus',
  'drops-car',
  'echo',
  'eco',
  'electric-motor',
  'electric-windscreen',
  'elevator',
  'ema-circled',
  'email',
  'email-open',
  'emission',
  'engine',
  'engine-coolant-temp',
  'enter',
  'equal',
  'eraser',
  'esc',
  'esc-off',
  'esc-slashed',
  'evasive-manoeuvre',
  'evasive-manoeuvre-assist',
  'exclamation-battery-standing',
  'exclamation-light-bulb',
  'exclamation-mark',
  'exclamation-mark-brake',
  'exclamation-mark-car',
  'exclamation-mark-circled',
  'expand-box',
  'external-link',
  'eye',
  'eye-exclamation-mark',
  'eye-semi-closed',
  'eye-slashed',
  'fabric',
  'fan',
  'fan-3-blade',
  'fan-car-front',
  'fan-seat-left',
  'fan-seat-left-auto',
  'fan-seat-right',
  'fan-seat-right-auto',
  'fan-slashed',
  'fast-charger',
  'feed',
  'ferry',
  'ferry-and-train',
  'file-csv',
  'file-txt',
  'file-xls',
  'filter',
  'filter-vertical',
  'filter-volume',
  'fire',
  'flag',
  'flower',
  'foglight-front',
  'foglight-rear',
  'folder',
  'fork-and-knife',
  'forward-collision-warning',
  'fridge',
  'front-sensor',
  'fuel-pump',
  'fuel-pump-circled',
  'fuel-pump-handle',
  'fuel-pump-hybrid',
  'fwd',
  'garage',
  'garage-car',
  'garden-tools',
  'gate',
  'ghost',
  'gift',
  'globe',
  'glovebox',
  'golf-bag',
  'graph-average',
  'graph-bars',
  'graph-bars-speedo',
  'graph-lines',
  'group',
  'h-brake',
  'hands-steering-wheel',
  'handshake',
  'hangtag',
  'hashtag',
  'headphones',
  'headset',
  'heart',
  'heart-hand',
  'heart-hands',
  'heart-light-bulb',
  'heat',
  'heat-seat-left',
  'heat-seat-left-auto',
  'heat-seat-right',
  'heat-seat-right-auto',
  'heat-steering-wheel',
  'heat-steering-wheel-auto',
  'heating',
  'high-beam',
  'high-beam-auto',
  'highway',
  'hill-upward-car-side',
  'home',
  'home-charger',
  'home-connected',
  'home-detailed',
  'home-low-beam',
  'home-work',
  'honk-and-flash',
  'hood',
  'horn',
  'hotspot',
  'hourglass',
  'hud',
  'hud-move',
  'hud-rotate',
  'human',
  'human-framed',
  'i-on-book',
  'id-card',
  'id-card-slashed',
  'image',
  'image-framed',
  'indicator-arrow-left',
  'indicator-arrow-right',
  'indicators',
  'indicators-trailer',
  'info-circled',
  'info-squared',
  'ion',
  'jerrycan',
  'key',
  'key-fob',
  'key-fob-connected',
  'key-loop-forward',
  'key-speed-limit',
  'key-tag',
  'keyboard',
  'keyboard-down',
  'keypad',
  'kitchen',
  'laptop',
  'lawnmower',
  'layers',
  'lca-left',
  'lca-right',
  'ldw-left',
  'ldw-right',
  'leaf',
  'leaf-circle-forward',
  'leaf-loop-backward',
  'leaf-loop-forward',
  'leaf-simple',
  'leather',
  'leave-the-car',
  'legal-hammer',
  'light-bulb',
  'light-left',
  'light-left-warning',
  'light-right',
  'light-right-warning',
  'light-trailer',
  'lightning-bolt',
  'lightning-bolt-circled',
  'lightning-bolt-circled-forward',
  'lightning-bolt-circled-staggered',
  'lightning-bolt-connected',
  'lightning-bolt-drop',
  'lights',
  'lights-adjust',
  'lights-adjust-down',
  'lights-adjust-up',
  'lim',
  'lines-horizontal',
  'link',
  'linked',
  'linked-broken',
  'list',
  'list-arrow',
  'list-checked',
  'list-square',
  'list-unchecked',
  'live',
  'lka',
  'lka-intervention-left',
  'lka-intervention-left-lines',
  'lka-intervention-right',
  'lka-intervention-right-lines',
  'lka-off',
  'lka-off-left',
  'lka-slashed',
  'lock',
  'lock-batteries',
  'lock-car',
  'lock-car-side-profile',
  'lock-open',
  'lock-open-trunk',
  'lock-shield',
  'lock-steering-wheel',
  'lock-trunk',
  'lock-wifi',
  'loop-backwards',
  'loop-backwards-dotted',
  'loop-backwards-rectangle',
  'loop-backwards-rounded',
  'loop-backwards-square',
  'loop-backwards-square-dotted',
  'loop-forward',
  'loop-forward-360',
  'loop-forward-car',
  'loop-forward-cube',
  'loop-forward-rectangle',
  'loop-forward-rectangle-1',
  'loop-forward-rectangle-1-squared',
  'loop-forward-rectangle-squared',
  'low-beam',
  'mail',
  'manual-transmission',
  'manual-tuning',
  'map',
  'map-pin',
  'map-pin-lightning-bolt',
  'mask',
  'massage-waves',
  'maximise',
  'megaphone',
  'memory-card',
  'menu',
  'merge',
  'message-phone',
  'microphone',
  'microphone-slashed',
  'microphone-speech-bubble',
  'minimise',
  'minus',
  'minus-circled',
  'mirror-left',
  'mirror-left-adjust',
  'mirror-left-fold',
  'mirror-left-tilt',
  'mirror-right',
  'mirror-right-adjust',
  'mirror-right-fold',
  'mirror-right-tilt',
  'mobile-phone',
  'mobile-phone-connected',
  'moon',
  'moon-phase',
  'moon-roof',
  'moon-z',
  'mountain',
  'mountains',
  'mountains-road',
  'mountains-straight-road',
  'navigation-arrow',
  'navigation-arrow-circled',
  'newspaper',
  'next',
  'northern-lights',
  'note',
  'note-profile',
  'note-slashed',
  'note-transmitting',
  'note-usb',
  'now-playing',
  'odo',
  'off',
  'office-building',
  'office-chair',
  'office-supplies',
  'oil',
  'oil-level',
  'ok',
  'on',
  'package',
  'paper-clip',
  'paper-plane',
  'papers',
  'papers-stacked',
  'papers-stacked-3d',
  'park-assist-camera',
  'parking',
  'parking-assist-phone',
  'parking-brake',
  'parking-brake-us',
  'parking-circled',
  'parking-finger',
  'parking-sensors',
  'parking-squared',
  'parking-squared-road',
  'parking-squared-route',
  'parking-steering-wheel',
  'pause',
  'pause-phone',
  'paw',
  'pedestrian-collision',
  'pegman',
  'pen',
  'pen-circled',
  'pen-paper',
  'people-square',
  'percentage-circled',
  'perfume-bottle',
  'phone',
  'phone-down',
  'phone-down-arrow',
  'phone-shield',
  'photo',
  'pin',
  'pin-car',
  'pin-road-ahead',
  'pin-road-left',
  'pin-road-right',
  'pin-square',
  'planet-hand',
  'play',
  'play-circled',
  'play-circled-dashed',
  'plug',
  'plug-ac',
  'plug-dc',
  'plus',
  'plus-car',
  'plus-circle-backwards',
  'plus-circle-forward',
  'plus-circled',
  'plus-circled-square-dotted',
  'plus-credit-card',
  'plus-mobile-phone',
  'plus-phone',
  'plus-search',
  'podium',
  'previous',
  'printer',
  'profile',
  'profile-arrows-in',
  'profile-arrows-out',
  'profile-car',
  'profile-circled',
  'profile-stars-auto',
  'profiles',
  'projector',
  'pump-charging',
  'qr-code-scanner',
  'question-mark',
  'question-mark-circled',
  'question-mark-circled-dotted',
  'queue',
  'r-brake',
  'r-brake-slashed',
  'radio',
  'rain',
  'rear-window-wiper',
  'rear-window-wiper-intermit',
  'receipt',
  'receipt-slashed',
  'record',
  'rectangle-arrow-out',
  'rectangle-portrait',
  'rectangle-portrait-hashed',
  'recycle',
  'remote-start',
  'restroom',
  'retailer',
  'ribbon',
  'road',
  'road-arrow',
  'road-segmented',
  'road-slashed',
  'road-trajectory-line',
  'roadside-arrow-left',
  'roadside-arrow-right',
  'roof-car',
  'rose',
  'rotate-car',
  'rotate-cube-3d',
  'rotate-photo',
  'route',
  'sand-dune',
  'satellite',
  'satellite-radio',
  'scale',
  'screen-clean',
  'screen-landscape',
  'screen-landscape-off',
  'screen-minus',
  'screen-plus',
  'screen-plus-play',
  'screen-portrait',
  'scribble',
  'search',
  'search-car',
  'search-car-pulse',
  'search-smart',
  'seat',
  'seat-4',
  'seat-7',
  'seat-belt',
  'seat-belt-adjust',
  'seat-belt-buckle',
  'seat-bolster',
  'seat-cushion',
  'seat-fold',
  'seat-headrest-fold',
  'seat-lean',
  'seat-lean-clock',
  'seat-left-massage-waves',
  'seat-lumbar',
  'seat-massage',
  'seat-right',
  'seat-right-bolster',
  'seat-right-cushion',
  'seat-right-lean',
  'seat-right-lumbar',
  'seat-right-massage',
  'seat-right-massage-waves',
  'seat-third-row',
  'sensor-car-inside',
  'sensor-car-inside-off',
  'set-speed-confirm-decline',
  'set-speed-default',
  'set-speed-resume',
  'share',
  'shield',
  'shield-checked',
  'shield-checked-car',
  'shield-device',
  'shield-plus',
  'shift',
  'shift-lock',
  'shopping-bag',
  'shuffle',
  'shuffle-squared',
  'shuffle-star',
  'shuffle-star-squared',
  'signed-paper',
  'smart-watch',
  'smiley-happy',
  'smiley-neutral',
  'smiley-sad',
  'smiley-slightly-happy',
  'smiley-slightly-sad',
  'snowflake',
  'snowflake-batteries',
  'snowflake-battery',
  'snowflake-battery-100',
  'snowflake-battery-20',
  'snowflake-battery-50',
  'snowflake-circle-forward',
  'snowflake-sun',
  'sos-call',
  'sound-bar',
  'space',
  'speaker',
  'speech-bubble',
  'speech-bubble-text',
  'speech-bubble-three-dots',
  'speech-bubbles',
  'speedo',
  'speedo-car',
  'speedo-enclosed',
  'speedo-max',
  'speedo-set',
  'spray-bottle',
  'square',
  'square-circled',
  'square-grid',
  'stack',
  'stacked-squares',
  'stacked-squares-car',
  'stalk-left-down',
  'stalk-left-up',
  'star',
  'star-circled',
  'star-half',
  'star-lines',
  'start',
  'steering-stacked',
  'steering-wheel',
  'steering-wheel-a-left',
  'steering-wheel-a-right',
  'steering-wheel-dashed-line',
  'steering-wheel-exclamation-mark',
  'steering-wheel-seat-left',
  'steering-wheel-seat-left-auto',
  'steering-wheel-seat-right',
  'steering-wheel-seat-right-auto',
  'steering-wheel-shield',
  'steering-wheel-trajectory',
  'step-backward',
  'step-downwards',
  'step-forward',
  'step-upwards',
  'stop-sign',
  'stopwatch',
  'storage',
  'stroller',
  'structure',
  'subtitles',
  'subtitles-slashed',
  'suitcase',
  'sun',
  'sun-and-cloud',
  'sun-car-side-profile',
  'sun-roof-close',
  'sun-roof-open',
  'sunset',
  'sunshade-close',
  'sunshade-open',
  'superhuman-light-bulb',
  'suspension',
  'swap-car',
  'switch-phone',
  'switch-view',
  'table',
  'temperature-cog',
  'tent',
  'three-dots',
  'thumbs-down',
  'thumbs-up',
  'time-interval-car',
  'timer',
  'tire',
  'tools',
  'touch',
  'tow-truck',
  'tpms',
  'tpms-tc',
  'trailer',
  'train',
  'trajectory-towbar',
  'trash-can',
  'trees',
  'triangle',
  'triangle-back',
  'triangle-down',
  'triangle-forward',
  'triangle-up',
  'trip-1',
  'trip-2',
  'trip-ta',
  'trip-tm',
  'trophy',
  'trunk-arrow',
  'trunk-open',
  'trunk-space',
  'turn-right-sign',
  'turtle',
  'tv',
  'twilight',
  'two-triangles-back',
  'two-triangles-forward',
  'unpin',
  'upload',
  'usb',
  'usb-symbol',
  'usd-circle-forward',
  'usd-coin',
  'video',
  'video-car',
  'video-framed',
  'voice-assistant-speaking',
  'volume',
  'volume-car',
  'volume-car-off',
  'volume-low',
  'volume-medium',
  'volume-off',
  'volume-off-speech-bubble',
  'volume-speech-bubble',
  'volume-x',
  'volvo-cars-app',
  'volvo-iron-mark',
  'wall-charger',
  'wallet',
  'warning',
  'warning-car',
  'warning-car-front',
  'warning-car-sensors',
  'warning-cars',
  'warning-coolant',
  'warning-door-sensor',
  'warning-eye',
  'warning-plug',
  'warning-speedo',
  'warning-speedo-off',
  'warning-speedo-slashed',
  'warning-towbar',
  'warning-triangle',
  'water-windscreen-wiper',
  'wheel',
  'wheel-moving',
  'wifi',
  'window',
  'window-x',
  'windscreen-washer',
  'windscreen-wiper',
  'workstation',
  'wrench',
  'wrench-and-screwdriver',
  'wrench-house',
  'wrench-papers',
  'x',
  'x-circled',
  'x-search',
] as const;

export const BRANDED_ICON_NAMES = [
  'amazon-key',
  'american-express',
  'android-auto',
  'apple-ar',
  'apple-carplay',
  'blogger',
  'cloud-radio',
  'dolby-atmos',
  'dolby-atmos-outlined',
  'facebook',
  'figma',
  'google',
  'google-assistant',
  'google-maps',
  'google-play',
  'hd-radio',
  'himalaya-music',
  'instagram',
  'line',
  'linkedin',
  'mastercard',
  'netease-cloud-music',
  'notion',
  'ovo',
  'pinterest',
  'qq-music',
  'salesforce',
  'threads',
  'visa',
  'vkontakte',
  'wechat',
  'weibo',
  'whatsapp',
  'x-app',
  'youtube',
] as const;
